module.exports = __webpack_public_path__ + "static/media/starPartial_326.b9d1cb79.png";